<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaAperturaDesde"
            :label-cols="labelCols"
            description="Desde que fecha de apertura"
            horizontal>
            <b-form-input 
              id="fechaAperturaDesde" 
              v-model="filtro.fechaAperturaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Hasta"
            label-for="fechaAperturaHasta"
            :label-cols="labelCols"
            description="Hasta que fecha de apertura"
            horizontal>
            <b-form-input 
              id="fechaAperturaHasta" 
              v-model="filtro.fechaAperturaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            :label-cols="labelCols"
            horizontal>
            <b-form-checkbox 
                id="incluirAbiertas"
                v-model="filtro.incluirAbiertas"
                :value="Boolean(true)"
                :unchecked-value="Boolean(false)">
                Incluir todas las cajas abiertas
            </b-form-checkbox>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <!-- <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button> -->
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    fechaAperturaDesde: {
      type: String,
      default: ''
    },
    fechaAperturaHasta: {
      type: String,
      default: ''
    },
    incluirAbiertas: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      filtro: {
        fechaAperturaDesde: '',
        fechaAperturaHasta: '',
        incluirAbiertas: true,
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 1
    }
  },
  created() {
      this.filtro.fechaAperturaDesde = moment.utc(this.fechaAperturaDesde).format('YYYY-MM-DD');
      this.filtro.fechaAperturaHasta = moment.utc(this.fechaAperturaHasta).format('YYYY-MM-DD');
      this.filtro.incluirAbiertas = this.incluirAbiertas;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    // limpiarFiltro() {
    // },
  },
}
</script>

<style>
</style>
